import { Route, Routes } from "react-router-dom";
import Login from "./Auth/Login/Login";
import Registeration from "./Auth/Registeration/Registeration";
import Companyinfo from "./Auth/Registeration/compdetails/companyinfo";
import Index from "./Pages/Dashboard/Dashboard";
import { ToastContainer } from "react-toastify";
import Emppersonalinfo from "./Pages/Employees/AddEmployees/Emppersonalinfo/Emppersonalinfo";
import Basicdetails from "./Pages/Employees/AddEmployees/Basicdetails/Basicdetails";
import Salarydetails from "./Pages/Employees/AddEmployees/Salarydetails/Salarydetails";
import Earnings from "./Pages/Salarycomponent/Earnings/Earnings";
import Deductions from "./Pages/Salarycomponent/Deductions/Deductions";
import Payment from "./Pages/Employees/AddEmployees/Payment/Payment";
import ViewEmployee from "./Pages/Employees/Employeeview/ViewEmployee";
import Vieweditdetails from "./Pages/Employees/EditEmployee/vieweditdetails/Vieweditdetails";
import Viewsalarydetails from "./Pages/Employees/EditEmployee/Viewsalarydetails/Viewsalarydetails";
import Editbasicinfo from "./Pages/Employees/EditEmployee/Editbasicinfo/Editbasicinfo";
import Editpersonalinfo from "./Pages/Employees/EditEmployee/Editpersonalinfo/Editpersonalinfo";
import Editpaymentinfo from "./Pages/Employees/EditEmployee/Editpaymentdetails/Editpaymentinfo";
import Editsalarydetails from "./Pages/Employees/EditEmployee/Editsalarydetails/Editsalarydetails";
import Viewleave from "./Pages/Leave/Viewleave/Viewleave";
import StaffLeave from "./Pages/Leave/StaffLeave/StaffLeave";
import Viewattendance from "./Pages/Attendance/Viewattendance/Viewattendance";
import Viewpayroll from "./Pages/Payroll/Viewpayroll/Viewpayroll";
import Viewsalaryslip from "./Pages/Payroll/Viewsalaryslip/Viewsalaryslip";
import Vieworgprofile from "./Pages/Settings/Organisation_profile/Vieworganisation_profile/Vieworg_profile";
import Home from "./Website/Home";
import Viewdepartment from "./Pages/Settings/Department/Viewdepartment";
import Viewdesignation from "./Pages/Settings/Designation/Viewdesignation";
import Viewdepartmenthd from "./Pages/Settings/Departmenthead/viewdepartmenthead";
import Viewdepartmenttl from "./Pages/Settings/Departmenttl/viewdepartmenttl";
import Changepassword from "./Pages/Settings/Changepassword/Changepassword";
import Leavecompo from "./Pages/Leavecomponent/Leavecomponent";
import { Provider } from "react-redux";
import { Store, persistor } from "./Store";
import { PersistGate } from "redux-persist/integration/react";
import Profile from "./Pages/ManageAccount/Profile";
import Privacypage from "./Pages/Settings/Privacy/privacy";
import Feedbackpage from "./Pages/Settings/Feedback/Feedback";
import HolidayView from "./Pages/Settings/Holiday/Holiday";
import PrivateRoute from "./PrivateRoute";
import ViewStaffAttendance from "./Pages/Attendance/Viewattendance/ViewStaffAttendance";
import Viewusersalary from "./Pages/ManageAccount/StaffProfile/usersalary";
import Edituserpersonalinfo from "./Pages/ManageAccount/StaffProfile/Edituserprofile/Edituserpersonalinfo";
import Staffprofile from "./Pages/ManageAccount/StaffProfile/Userprofile";
import Edituserbasicinfo from "./Pages/ManageAccount/StaffProfile/Edituserprofile/Edituserbasicdetails";
import ViewStaffPayroll from "./Pages/Payroll/Viewpayroll/ViewStaffPayroll";
import Forgetpass from "./Auth/Forgetpass/Forgetpass";
import IncompleteEmployee from "./Pages/Employees/Employeeview/Pendingemp";
import { HashRouter } from "react-router-dom";
import DashboardStaff from "./Pages/Dashboard/DashboardStaff";
import Logs from "./Pages/Settings/Logs/Logs";
import ViewUser from "./Pages/Settings/UserandRoles/ViewUser";
import ViewRoles from "./Pages/Settings/UserandRoles/Roles";
import Adduser from "./Pages/Settings/UserandRoles/AddUser";
import DashboardOtherUser from "./Pages/Dashboard/DashboardOtherUser";
import OtherComponent from "./Pages/Salarycomponent/OtherComponet/OtherComponet";
import UnauthorizedPage from "./Unauth/Unauth";
import UploadExcelNote from "./Pages/Attendance/Uploadexcel/UploadExcelNote";
import Requestuniqueid from "./Pages/Request/Requestuniqueid";
import Viewedituniqueid from "./Pages/Request/Viewedituniqueid";
import Addrequestdetails from "./Pages/Request/Addrequestdetails";

function App() {
  return (
    <HashRouter>
      <ToastContainer />
      <Provider store={Store}>
        <PersistGate loading={null} persistor={persistor}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<Forgetpass />} />
            <Route path="/signup" element={<Registeration />} />
            <Route path="/compdetails" element={<Companyinfo />} />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute
                  element={<Index />}
                  roles={["Company"]}
                  action="dashboard"
                  subaction="view"
                />
              }
            />
            <Route
              path="/dashboardother"
              element={
                <PrivateRoute
                  element={<DashboardOtherUser />}
                  roles={["other_user"]}
                  action="dashboard"
                  subaction="view"
                />
              }
            />

            <Route
              path="/dashboardstaff"
              element={
                <PrivateRoute element={<DashboardStaff />} roles={["staff"]} />
              }
            />

            <Route
              path="/employee"
              element={
                <PrivateRoute
                  element={<ViewEmployee />}
                  roles={["Company", "other_user"]}
                  action="employee"
                  subaction="view"
                />
              }
            />
            <Route
              path="/incompemployee"
              element={
                <PrivateRoute
                  element={<IncompleteEmployee />}
                  roles={["Company", "other_user"]}
                  action="employee"
                  subaction="add"
                />
              }
            />
            <Route
              path="/addemployee"
              element={
                <PrivateRoute
                  element={<Emppersonalinfo />}
                  roles={["Company", "other_user"]}
                  action="employee"
                  subaction="add"
                />
              }
            />
            <Route
              path="/basicdetails"
              element={
                <PrivateRoute
                  element={<Basicdetails />}
                  roles={["Company", "other_user"]}
                  action="employee"
                  subaction="add"
                />
              }
            />
            <Route
              path="/salarydetails"
              element={
                <PrivateRoute
                  element={<Salarydetails />}
                  roles={["Company", "other_user"]}
                  action="employee"
                  subaction="add"
                />
              }
            />
            <Route
              path="/addearningcomp"
              element={
                <PrivateRoute
                  element={<Earnings />}
                  roles={["Company", "other_user"]}
                  action="salary_component"
                  subaction="view"
                />
              }
            />
            <Route
              path="/otherComp"
              element={
                <PrivateRoute
                  element={<OtherComponent />}
                  roles={["Company", "other_user"]}
                  action="salary_component"
                  subaction="view"
                />
              }
            />
            <Route
              path="/adddeductioncomp"
              element={
                <PrivateRoute
                  element={<Deductions />}
                  roles={["Company", "other_user"]}
                  action="salary_component"
                  subaction="view"
                />
              }
            />
            <Route
              path="/addpayment"
              element={
                <PrivateRoute
                  element={<Payment />}
                  roles={["Company", "other_user"]}
                  action="employee"
                  subaction="add"
                />
              }
            />
            <Route
              path="/vieweditdetails"
              element={
                <PrivateRoute
                  element={<Vieweditdetails />}
                  roles={["Company", "other_user"]}
                  action="employee"
                  subaction="edit"
                />
              }
            />
            <Route
              path="/editbasicinfo"
              element={
                <PrivateRoute
                  element={<Editbasicinfo />}
                  roles={["Company", "other_user"]}
                  action="employee"
                  subaction="edit"
                />
              }
            />
            <Route
              path="/viewsalarydetails"
              element={
                <PrivateRoute
                  element={<Viewsalarydetails />}
                  roles={["Company", "other_user"]}
                  action="employee"
                  subaction="view"
                />
              }
            />
            <Route
              path="/editpersonalinfo"
              element={
                <PrivateRoute
                  element={<Editpersonalinfo />}
                  roles={["Company", "other_user"]}
                  action="employee"
                  subaction="add"
                />
              }
            />
            <Route
              path="/editpaymentinfo"
              element={
                <PrivateRoute
                  element={<Editpaymentinfo />}
                  roles={["Company", "other_user"]}
                  action="employee"
                  subaction="edit"
                />
              }
            />
            <Route
              path="/editsalarydetails"
              element={
                <PrivateRoute
                  element={<Editsalarydetails />}
                  roles={["Company", "other_user"]}
                  action="employee"
                  subaction="edit"
                />
              }
            />
            <Route
              path="/viewleave"
              element={
                <PrivateRoute
                  element={<Viewleave />}
                  roles={["Company", "other_user"]}
                  action="leave"
                  subaction="view"
                />
              }
            />
            <Route
              path="/staffLeave"
              element={
                <PrivateRoute element={<StaffLeave />} roles={["staff"]} />
              }
            />
            <Route
              path="/staffprofile"
              element={
                <PrivateRoute element={<Staffprofile />} roles={["staff"]} />
              }
            />
            <Route
              path="/staffsalary"
              element={
                <PrivateRoute element={<Viewusersalary />} roles={["staff"]} />
              }
            />
            <Route
              path="/viewattendance"
              element={
                <PrivateRoute
                  element={<Viewattendance />}
                  roles={["Company", "other_user"]}
                  action="attendance"
                  subaction="view"
                />
              }
            />
            <Route
              path="/viewpayroll"
              element={
                <PrivateRoute
                  element={<Viewpayroll />}
                  roles={["Company", "other_user"]}
                  action="payroll"
                  subaction="view"
                />
              }
            />
            <Route
              path="/viewsalaryslip"
              element={
                <PrivateRoute
                  element={<Viewsalaryslip />}
                  roles={["Company", "other_user"]}
                  action="payroll"
                  subaction="view"
                />
              }
            />
            <Route
              path="/vieworgprofile"
              element={
                <PrivateRoute
                  element={<Vieworgprofile />}
                  roles={["Company"]}
                />
              }
            />
            <Route
              path="/viewdep"
              element={
                <PrivateRoute
                  element={<Viewdepartment />}
                  roles={["Company", "other_user"]}
                  action="department"
                  subaction="view"
                />
              }
            />
            <Route
              path="/viewdesignation"
              element={
                <PrivateRoute
                  element={<Viewdesignation />}
                  roles={["Company", "other_user"]}
                  action="designation"
                  subaction="view"
                />
              }
            />
            <Route
              path="/viewdephead"
              element={
                <PrivateRoute
                  element={<Viewdepartmenthd />}
                  roles={["Company", "other_user"]}
                  action="department_head"
                  subaction="view"
                />
              }
            />
            <Route
              path="/viewdeptl"
              element={
                <PrivateRoute
                  element={<Viewdepartmenttl />}
                  roles={["Company", "other_user"]}
                  action="department_tl"
                  subaction="view"
                />
              }
            />
            {/* <Route path='/changepass'
              element={<PrivateRoute element={<Changepassword />}
                roles={["Company", "staff","other_user"]} />}
            /> */}
            {/* <Route path="/changepass" element={<Changepassword />} /> */}

            <Route
              path="/changepass"
              element={
                <PrivateRoute
                  element={<Changepassword />}
                  roles={["Company", "other_user", "staff"]}
                  action="changepassword"
                  subaction="view"
                />
              }
            />
            <Route
              path="/privacy"
              element={
                <PrivateRoute
                  element={<Privacypage />}
                  roles={["Company"]}
                  action="privacy"
                  subaction="view"
                />
              }
            />
            {/* <Route path='/privacy' element={<Privacypage />} /> */}
            <Route
              path="/Uploadexcelnote"
              element={
                <PrivateRoute
                  element={<UploadExcelNote />}
                  roles={["Company", "other_user"]}
                  action="uploadExcelNote"
                  subaction="view"
                />
              }
            />
            {/* <Route path='/privacy' element={<Privacypage />} /> */}

            {/* <Route path='/Uploadexcelnote' element={<UploadExcelNote />} /> */}

            <Route
              path="/viewleavecomp"
              element={
                <PrivateRoute
                  element={<Leavecompo />}
                  roles={["Company", "other_user"]}
                  action="leave_component"
                  subaction="view"
                />
              }
            />
            <Route
              path="/viewprofile"
              element={
                <PrivateRoute
                  element={<Profile />}
                  roles={["Company", "other_user"]}
                />
              }
            />

            {/* <Route path='/privacy' element={<Privacypage />} /> */}
            <Route path="/Uploadexcelnote" element={<UploadExcelNote />} />

            <Route path="/feedback" element={<Feedbackpage />} />
            <Route
              path="/holiday"
              element={
                <PrivateRoute
                  element={<HolidayView />}
                  roles={["Company", "other_user"]}
                  action="holiday"
                  subaction="view"
                />
              }
            />
            <Route
              path="/viewstaffattendance"
              element={
                <PrivateRoute
                  element={<ViewStaffAttendance />}
                  roles={["staff"]}
                />
              }
            />
            <Route
              path="/editstaffpersonalinfo"
              element={
                <PrivateRoute
                  element={<Edituserpersonalinfo />}
                  roles={["staff"]}
                />
              }
            />
            <Route
              path="/editstaffbasic"
              element={
                <PrivateRoute
                  element={<Edituserbasicinfo />}
                  roles={["staff"]}
                />
              }
            />
            <Route
              path="/viewstaffpayroll"
              element={
                <PrivateRoute
                  element={<ViewStaffPayroll />}
                  roles={["staff"]}
                />
              }
            />
            <Route
              path="/viewuser"
              element={
                <PrivateRoute element={<ViewUser />} roles={["Company"]} />
              }
            />
            <Route
              path="/viewroles"
              element={
                <PrivateRoute element={<ViewRoles />} roles={["Company"]} />
              }
            />
            <Route
              path="/adduser"
              element={
                <PrivateRoute element={<Adduser />} roles={["Company"]} />
              }
            />
            <Route path="Requestuniqueid" element={<Requestuniqueid/>} roles={["Company"]}  />
            <Route path="Viewedituniqueid" element={<Viewedituniqueid/>} roles={["Company"]} />
            <Route path="Addrequestdetails" element={<Addrequestdetails/>} roles={["Company"]} />
            <Route
              path="/viewlogs"
              element={<PrivateRoute element={<Logs />} roles={["Company"]}  />}
            />
            <Route path="/unauthorized" element={<UnauthorizedPage />} />
          </Routes>
        </PersistGate>
      </Provider>
    </HashRouter>
  );
}

export default App;
